module.exports = __webpack_public_path__ + "img/bg31.72cc5b23.jpg";